document.addEventListener("DOMContentLoaded", function () {
  (function () {
    "use strict";

    let footer,
      footerInner,
      stickyFooterElement,
      footerHeight,
      footerScaleRatio,
      isFooterVisible = false;

    function isLargeScreen() {
      return window.innerWidth > 990;
    }

    function initFooter(e) {
      if (!isLargeScreen()) {
        return;
      }
      footer = document.querySelector(e);
      footerInner = footer.querySelector(".footer__inner");
      stickyFooterElement = document.querySelector(
        ".sticky-footer-click-through-element"
      );
      bindEvents();
    }

    function bindEvents() {
      const resizeHandler = function () {
        if (isLargeScreen()) {
          updateFooterHeight();
        } else {
          resetFooter();
        }
      };

      resizeHandler();

      window.addEventListener("resize", resizeHandler);
      window.addEventListener("scroll", function () {
        if (isLargeScreen()) {
          updateFooterVisibility(window.pageYOffset || window.scrollY);
        }
      });

      document.querySelectorAll(".footer__details").forEach((detail) => {
        detail.addEventListener("toggle", handleDetailsToggle);
      });

      [1500, 3000, 5000, 9000].forEach((delay) => {
        setTimeout(resizeHandler, delay);
      });
    }

    function resetFooter() {
      isFooterVisible = false;
      document.body.classList.remove("footer-visible", "footer-full-visible");
      if (stickyFooterElement) {
        stickyFooterElement.style.height = "";
        stickyFooterElement.style.backgroundColor = "";
      }
      if (footerInner) {
        footerInner.style.opacity = "";
      }
    }

    function updateFooterHeight() {
      if (!isLargeScreen()) {
        return;
      }
      footerHeight = footer.scrollHeight;
      stickyFooterElement.style.height = footerHeight + "px";
      footerScaleRatio = window.innerWidth < 900 ? 0.7 : 0.9;
    }

    function updateFooterVisibility(scrollY) {
      if (!isLargeScreen()) {
        return;
      }

      const bodyOffset =
        document.body.offsetHeight - window.innerHeight - scrollY;

      const threshold = 50;

      if (bodyOffset > footerHeight + threshold) {
        if (isFooterVisible) {
          isFooterVisible = false;
          document.body.classList.remove("footer-visible");
          document.body.classList.remove("footer-full-visible");
        }
        return;
      }

      if (!isFooterVisible && bodyOffset <= footerHeight - threshold) {
        isFooterVisible = true;
        document.body.classList.add("footer-visible");
      }

      isFooterVisible = true;
      document.body.classList.add("footer-visible");

      const scrollRatio = bodyOffset / (footerHeight * 0.87);
      stickyFooterElement.style.backgroundColor =
        "rgba(0,0,0," + scrollRatio + ")";
      const border = document.querySelector(".new-footer__border");
      const scaleRatio = Math.min(
        footerScaleRatio + (1 - footerScaleRatio) * (1 - scrollRatio),
        1
      );
      footerInner.style.opacity = scaleRatio;

      if (scaleRatio === 1) {
        document.body.classList.add("footer-full-visible");
      } else {
        document.body.classList.remove("footer-full-visible");
      }
    }

    function handleDetailsToggle(event) {
      if (!isLargeScreen()) {
        return;
      }
      setTimeout(() => {
        updateFooterHeight();
        const scrollPosition = window.pageYOffset || window.scrollY;
        updateFooterVisibility(scrollPosition);

        const bodyHeight = document.body.offsetHeight;
        const windowHeight = window.innerHeight;
        const bottomPosition = bodyHeight - windowHeight;

        if (scrollPosition < bottomPosition) {
          window.scrollTo({
            top: bottomPosition,
            behavior: "smooth",
          });
        }
      }, 50);
    }
    initFooter(".footer");
  })();
});